export default __webpack_public_path__ + "1f00634704ae403658de87e22dd21151.png";